import {
  Box,
  Drawer,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";
import AssessmentIcon from "@mui/icons-material/Assessment";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import React from "react";
import RuleIcon from "@mui/icons-material/Rule";
import RadarIcon from "@mui/icons-material/Radar";
import FlagIcon from "@mui/icons-material/Flag";
import SchoolIcon from "@mui/icons-material/School";
import DashboardIcon from "@mui/icons-material/Dashboard";
import { useAuth } from "../context/AuthContext";
import { useThemeMode } from "../context/ThemeContext";
import { useNavigate } from "react-router-dom";
import BugReportIcon from "@mui/icons-material/BugReport";
import EditNoteIcon from "@mui/icons-material/EditNote";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";

export const ADMIN_TOOLS = [
  {
    id: "dashboard",
    label: "Analytics Dashboard",
    icon: <DashboardIcon fontSize="small" />,
    description: "Token trends, service mix, and usage insights",
    tag: "Overview",
    allowedRoles: ["admin", "analytics_viewer", "user_admin"],
  },
];

export const TOOL_CATEGORIES = [
  {
    category: "Migration",
    id: "cat-migration",
    icon: <SwapHorizIcon fontSize="small" />,
    tools: [
      {
        id: "migration-up",
        label: "UP",
        icon: <SwapHorizIcon fontSize="small" />,
        description: "UP to AE Migration",
        tag: "UP",
        allowedRoles: ["migration_uipath", "admin"],
      },
      {
        id: "migration-bp",
        label: "BP",
        icon: <SwapHorizIcon fontSize="small" />,
        description: "BP to AE Migration",
        tag: "BP",
        allowedRoles: ["migration_bp", "admin"],
      },
      {
        id: "migration-aa",
        label: "AA",
        icon: <SwapHorizIcon fontSize="small" />,
        description: "AA to AE Migration",
        tag: "AA",
        allowedRoles: ["migration_aa", "admin"],
      },
      {
        id: "migration-selenium",
        label: "Selenium",
        icon: <SwapHorizIcon fontSize="small" />,
        description: "Selenium to AE Migration",
        tag: "Selenium",
        allowedRoles: ["migration_selenium", "admin"],
      }
    ]
  },
  {
    category: "Chatbot",
    id: "cat-chatbot",
    icon: <AutoAwesomeIcon fontSize="small" />,
    tools: [
      {
        id: "ai-studio",
        label: "AI Studio",
        icon: <AutoAwesomeIcon fontSize="small" />,
        description: "Build & Test AI workflows",
        tag: "Studio",
        allowedRoles: ["ai_studio", "admin"],
      }
    ]
  },
  {
    category: "APA Lifecycle",
    id: "cat-lifecycle",
    icon: <RuleIcon fontSize="small" />,
    tools: [
      {
        id: "proposal",
        label: "Proposal",
        icon: <ChatBubbleOutlineIcon fontSize="small" />,
        description: "Professional services and AE agents Threads",
        tag: "Proposals",
        allowedRoles: ["proposal", "admin"],
      },
      {
        id: "brd",
        label: "BRD Creation",
        icon: <ArticleOutlinedIcon fontSize="small" />,
        description: "Business Requirement Documents",
        tag: "Documents",
        allowedRoles: ["brd", "admin"],
      },
      {
        id: "Project-Documentation",
        label: "Solution Design Document",
        icon: <ArticleOutlinedIcon fontSize="small" />,
        description: "SDD Creation using BRD and Re-engineering Documents.",
        tag: "BRD & Re-engineering to SDD",
        allowedRoles: ["brd_to_sdd", "admin"],
      },
      {
        id: "test-case",
        label: "Test Cases",
        icon: <BugReportIcon fontSize="small" />,
        description: "From business requirement documents and solution design documents",
        tag: "Testing",
        allowedRoles: ["test_case", "admin"],
      },
      {
        id: "code-review",
        label: "Code Review",
        icon: <RuleIcon fontSize="small" />,
        description: "Review workflows, process and project zip against SDD and AE coding standard",
        tag: "Review",
        allowedRoles: ["code_review", "admin"],
      },
    {
        id: "Smart Log Analyzer",
        label: "Log Analysis",
        icon: <AssessmentIcon fontSize="small" />,
        description: "Analyze AE Logs & Errors",
        tag: "Logs",
        allowedRoles: ["log_analyzer", "admin"],
      },
    {
        id: "support-copilot",
        label: "AE Support",
        icon: <SupportAgentIcon fontSize="small" />,
        description: "AI-assisted incident triage, SOP knowledge base & Teams support workflows",
        tag: "Support",
        allowedRoles: ["support_copilot", "SUPPORT_ADMIN", "SUPPORT_SENIOR", "SUPPORT_JUNIOR", "SUPPORT_BUSINESS", "admin"],
      },


      
    ]
  },
  {
    category: "AE Trainings",
    id: "cat-eval",
    icon: <SchoolIcon fontSize="small" />,
    tools: [
      {
        id: "training-eval",
        label: "Evaluation",
        icon: <SchoolIcon fontSize="small" />,
        description: "AE Training Evaluation",
        tag: "Training",
        allowedRoles: ["training_team", "admin"],
      }
    ]
  },
  {
    category: "Customer Success Management",
    id: "cat-csm",
    icon: <RadarIcon fontSize="small" />,
    tools: [
      {
        id: "csm",
        label: "CSM",
        icon: <RadarIcon fontSize="small" />,
        description: "Customer Success & Risk Analytics",
        tag: "Intelligence",


        allowedRoles: ["csm", "csm_admin", "csm_super_admin", "admin"],
      },
      {
        id: "csm-india",
        label: "CSM India",
        icon: <FlagIcon fontSize="small" />,
        description: "Adoption & pain signal console",
        tag: "India",

        allowedRoles: ["csm_india", "admin"],
      },
      {
        id: "ba-assist",
        label: "BA Assist",
        icon: <AccountTreeIcon fontSize="small" />,
        description: "Chat with the BA context graph, analyze BRD updates, export Gemini Gem prompt",
        tag: "BA Graph",
      
      
        allowedRoles: ["ba_assist", "ba_assist_admin", "admin"],
      },
    ]
  },
  {
    category: "Other",
    id: "cat-other",
    icon: <EditNoteIcon fontSize="small" />,
    tools: [
      {
        id: "mom",
        label: "Minutes of Meeting",
        icon: <EditNoteIcon fontSize="small" />,
        description: "Generate MoM from Transcript",
        tag: "MoM",
        allowedRoles: ["mom", "admin"],
      },
      {
        id: "Process-Analysis",
        label: "Reverse Engineering",
        icon: <SwapHorizIcon fontSize="small" />,
        description: "From workflows, process and project Zip",
        tag: "Reverse Engineering",
        allowedRoles: ["wf_to_sdd", "admin"],
      },
    ]
  },
  {
    category: "Email Automation",
    id: "cat-email-automation",
    icon: <MarkEmailReadIcon fontSize="small" />,
    tools: [
      {
        id: "email-automation",
        label: "Email Automation",
        icon: <MarkEmailReadIcon fontSize="small" />,
        description: "Paste a customer email to classify it and draft a reply for review",
        tag: "Email",
        allowedRoles: ["email_automation", "admin"],
      },
    ]
  },
];

export const TOOLS = TOOL_CATEGORIES.flatMap(cat => cat.tools);

const AELogoMark = () => (
  <Box
    sx={{
      width: 32,
      height: 32,
      borderRadius: "8px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
      overflow: "hidden"
    }}
  >
    <img src="/ae-icon.png" alt="AE" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
  </Box>
);

export default function Sidebar({
  activeTool,
  onSelectTool,
  activeCategory,
  onSelectCategory,
  collapsed,
  onToggle,
  sidebarWidth,
  sidebarCollapsed,
  onOpenChangePassword,
}) {
  const { user, logout } = useAuth();
  const { mode, toggleTheme } = useThemeMode();
  const navigate = useNavigate();
  const drawerWidth = collapsed ? sidebarCollapsed : sidebarWidth;

  const handleCategoryClick = (category) => {
    if (collapsed) return;
    if (onSelectCategory) onSelectCategory(category);
  };

  const visibleCategories = TOOL_CATEGORIES.map(category => {
    return {
      ...category,
      tools: category.tools.filter(
        (t) => user?.roles?.includes("admin") || t.allowedRoles.some(r => user?.roles?.includes(r))
      )
    };
  }).filter(category => category.tools.length > 0);

  const visibleAdminTools = ADMIN_TOOLS.filter(
    (t) => user?.roles?.includes("admin") || t.allowedRoles?.some(r => user?.roles?.includes(r))
  );

  return (
    <Drawer
      variant="permanent"
      PaperProps={{
        sx: {
          width: drawerWidth,
          bgcolor: "transparent",
          border: "none",
          transition: "width 0.22s cubic-bezier(0.4,0,0.2,1)",
          overflow: "visible",
          boxShadow: "none",
        }
      }}
      sx={{
        width: drawerWidth,
        flexShrink: 0,
      }}
    >
      {/* Hidden SVG — liquid warp on glass edges */}
      <svg style={{ display: "none", position: "absolute" }} aria-hidden>
        <defs>
          <filter id="sidebar-liquid" x="-5%" y="-5%" width="110%" height="110%" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
            <feTurbulence type="fractalNoise" baseFrequency="0.004 0.008" numOctaves="1" result="turbulence" />
            <feDisplacementMap in="SourceGraphic" in2="turbulence" scale="6" xChannelSelector="R" yChannelSelector="G" />
          </filter>
        </defs>
      </svg>

      <Box
        sx={{
          height: "calc(100vh - 24px)",
          margin: 1.5,
          marginRight: 0.75,
          borderRadius: "var(--radius)",
          background: mode === 'light'
            ? "rgba(255,255,255,0.42)"
            : "rgba(8,18,34,0.40)",
          backdropFilter: "blur(28px)",
          WebkitBackdropFilter: "blur(28px)",
          border: "1px solid rgba(255,255,255,0.35)",
          boxShadow: mode === 'light'
            ? "inset 3px 3px 3px rgba(255,255,255,0.55), inset -3px -3px 3px rgba(255,255,255,0.28), 0 12px 40px rgba(0,0,0,0.14), 0 4px 12px rgba(0,0,0,0.08)"
            : "inset 3px 3px 3px rgba(255,255,255,0.08), inset -3px -3px 3px rgba(255,255,255,0.03), 0 18px 48px rgba(0,0,0,0.40), 0 4px 14px rgba(0,0,0,0.18)",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          transition: "width 0.22s cubic-bezier(0.4,0,0.2,1)",
          position: "relative",
          "&::before": {
            content: '""',
            position: "absolute",
            inset: 0,
            background: mode === 'light'
              ? "radial-gradient(circle at top left, rgba(242,101,34,0.22) 0%, transparent 38%), radial-gradient(circle at bottom right, rgba(80,140,255,0.14) 0%, transparent 32%), radial-gradient(circle at 70% 40%, rgba(180,80,255,0.08) 0%, transparent 28%)"
              : "radial-gradient(circle at top left, rgba(242,101,34,0.28) 0%, transparent 35%), radial-gradient(circle at bottom right, rgba(80,140,255,0.18) 0%, transparent 30%), radial-gradient(circle at 70% 40%, rgba(180,80,255,0.12) 0%, transparent 26%)",
            pointerEvents: "none",
            zIndex: 0,
          },
        }}
      >
        {/* ── Logo ── */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: collapsed ? "center" : "space-between",
            gap: collapsed ? 0 : 1.2,
            px: collapsed ? 0.5 : 2,
            py: 0,
            minHeight: "68px",
            position: "relative",
            flexShrink: 0,
            borderBottom: "1px solid rgba(255,255,255,0.18)",
            background: mode === 'light'
              ? "rgba(255,255,255,0.55)"
              : "rgba(8,18,34,0.55)",
            backdropFilter: "blur(16px)",
            WebkitBackdropFilter: "blur(16px)",
            zIndex: 1,
          }}
        >
          {collapsed ? (
            <AELogoMark />
          ) : (
            <Box
              sx={{
                flex: 1,
                display: "flex",
                alignItems: "center",
                transition: "all 0.3s ease",
                cursor: "pointer",
                "&:hover": {
                  transform: "scale(1.03)",
                }
              }}
              onClick={() => navigate("/")}
            >
              <img
                src={mode === 'light' ? "/edge-ai-logo-black.png" : "/edge-ai-logo-white.png"}
                alt="Assist-Edgex"
                style={{
                  height: "20px",
                  objectFit: "contain",
                  maxWidth: "135px",
                  filter: mode === 'dark' ? "drop-shadow(0 0 12px rgba(242,101,34,0.15))" : "none"
                }}
              />
            </Box>
          )}

          {/* Theme Toggle */}
          {!collapsed && (
            <Tooltip title={mode === 'dark' ? "Switch to Light Mode" : "Switch to Dark Mode"}>
              <IconButton
                onClick={toggleTheme}
                size="small"
                sx={{
                  color: "#F26522",
                  bgcolor: "var(--ae-surface)",
                  mr: 1,
                  "&:hover": { bgcolor: "var(--ae-surface-hover)" }
                }}
              >
                {mode === 'dark' ? <LightModeIcon sx={{ fontSize: 18 }} /> : <DarkModeIcon sx={{ fontSize: 18 }} />}
              </IconButton>
            </Tooltip>
          )}

          <IconButton
            onClick={onToggle}
            size="small"
            sx={{
              flexShrink: 0,
              background: "var(--ae-navy-mid)",
              border: "1px solid var(--ae-border)",
              color: "#8fa3c0",
              padding: "4px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.4)",
              "&:hover": { background: "var(--ae-orange)", color: "#fff", borderColor: "var(--ae-orange)" },
              zIndex: 100,
              mr: collapsed ? 0 : 0,
            }}
          >
            <ChevronLeftIcon
              sx={{
                fontSize: 16,
                transform: collapsed ? "rotate(180deg)" : "none",
                transition: "transform 0.3s ease",
              }}
            />
          </IconButton>
        </Box>

        {/* ── Tools ── */}
        <Box
          sx={{
            flex: 1,
            py: 2,
            px: collapsed ? 0.5 : 1.5,
            overflowY: "auto",
            overflowX: "hidden",
            mt: 0.75,
            position: "relative",
            "&::-webkit-scrollbar": { width: "4px" },
            "&::-webkit-scrollbar-track": { background: "transparent" },
            "&::-webkit-scrollbar-thumb": {
              background: mode === 'light' ? "rgba(0,0,0,0.1)" : "rgba(255,255,255,0.05)",
              borderRadius: "10px",
            },
            "&::-webkit-scrollbar-thumb:hover": { background: "var(--ae-orange)" }
          }}
        >
          <Typography
            sx={{
              fontSize: "10px",
              fontWeight: 700,
              color: mode === 'light' ? "#64748b" : "#8fa3c0",
              textTransform: "uppercase",
              letterSpacing: "1px",
              mb: 2,
              px: 1,
              opacity: collapsed ? 0 : 1,
            }}
          >
            Tools
          </Typography>

          <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
            {visibleCategories.map((category) => {
              return (
                <Box key={category.id} sx={{ mb: 1 }}>
                  {/* Category Header */}
                  <Box
                    onClick={() => handleCategoryClick(category)}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: collapsed ? "center" : "space-between",
                      px: collapsed ? 0 : 1.5,
                      py: 0.9,
                      cursor: collapsed ? "default" : "pointer",
                      borderRadius: "8px",
                      position: "relative",
                      background: !collapsed && activeCategory?.id === category.id
                        ? (mode === 'light' ? "rgba(242,101,34,0.08)" : "rgba(242,101,34,0.12)")
                        : "transparent",
                      border: "1px solid",
                      borderColor: !collapsed && activeCategory?.id === category.id
                        ? "rgba(242,101,34,0.2)"
                        : "transparent",
                      "&:hover": {
                        background: collapsed ? "transparent" : (mode === 'light' ? "rgba(0,0,0,0.03)" : "rgba(255,255,255,0.04)"),
                      },
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, width: collapsed ? "100%" : "auto", justifyContent: collapsed ? "center" : "flex-start" }}>
                      <Box sx={{ color: "#8fa3c0", display: "flex" }}>
                        {category.icon}
                      </Box>
                      {!collapsed && (
                        <Typography
                          sx={{
                            fontSize: "10px",
                            fontWeight: 700,
                            color: mode === 'light' ? "#64748b" : "#8fa3c0",
                            textTransform: "uppercase",
                            letterSpacing: "0.5px",
                          }}
                        >
                          {category.category}
                        </Typography>
                      )}
                    </Box>

                  </Box>


                </Box>
              );
            })}
          </Box>

          {/* ── Management (Admin) Section ── */}
          {visibleAdminTools.length > 0 && (
            <Box sx={{ mt: 3.5, mb: 1 }}>
              <Typography
                sx={{
                  fontSize: "10px",
                  fontWeight: 700,
                  color: mode === 'light' ? "#64748b" : "#8fa3c0",
                  textTransform: "uppercase",
                  letterSpacing: "1px",
                  mb: 1.5,
                  px: 1,
                  opacity: collapsed ? 0 : 1,
                }}
              >
                Management
              </Typography>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
                {visibleAdminTools.map((tool) => {
                  const isActive = activeTool?.id === tool.id;
                  return (
                    <Tooltip
                      key={tool.id}
                      title={collapsed ? tool.label : ""}
                      placement="right"
                    >
                      <Box
                        onClick={() => onSelectTool(tool)}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: collapsed ? "center" : "flex-start",
                          gap: 1.5,
                          px: collapsed ? 0 : 1.5,
                          py: 0.85,
                          borderRadius: "12px",
                          cursor: "pointer",
                          position: "relative",
                          transition: "all 0.2s ease",
                          boxShadow: isActive
                            ? (mode === 'light' ? "0 8px 18px rgba(242,101,34,0.12)" : "0 10px 22px rgba(242,101,34,0.18)")
                            : "none",
                          background: isActive
                            ? (mode === 'light' ? "rgba(242,101,34,0.12)" : "rgba(242,101,34,0.14)")
                            : "transparent",
                          border: "1px solid",
                          borderColor: isActive
                            ? "rgba(242,101,34,0.25)"
                            : "transparent",
                          width: collapsed ? "44px" : "100%",
                          mx: "auto",
                          "&:hover": {
                            background: isActive
                              ? "rgba(242,101,34,0.15)"
                              : (mode === 'light' ? "rgba(0,0,0,0.03)" : "rgba(255,255,255,0.04)"),
                            transform: collapsed ? "none" : "translateX(4px)",
                          },
                        }}
                      >
                        <Box
                          sx={{
                            color: isActive ? "#F26522" : "#8fa3c0",
                            display: "flex",
                            transition: "color 0.2s ease",
                          }}
                        >
                          {tool.icon}
                        </Box>

                        {!collapsed && (
                          <Box sx={{ flex: 1, overflow: "hidden" }}>
                            <Typography
                              sx={{
                                fontSize: "11.5px",
                                fontWeight: isActive ? 600 : 500,
                                color: isActive ? "var(--ae-orange)" : "text.primary",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {tool.label}
                            </Typography>
                          </Box>
                        )}
                        {isActive && !collapsed && (
                          <Box
                            sx={{
                              width: 3,
                              height: 16,
                              background: "#F26522",
                              borderRadius: "10px",
                              boxShadow: "0 0 8px rgba(242,101,34,0.5)",
                            }}
                          />
                        )}
                      </Box>
                    </Tooltip>
                  );
                })}
              </Box>
            </Box>
          )}
        </Box>

        {/* ── Footer ── */}
        <Box
          sx={{
            px: collapsed ? 0 : 1.5,
            py: 1.25,
            borderTop: "1px solid rgba(255,255,255,0.14)",
            background: mode === 'light' ? "rgba(255,255,255,0.40)" : "rgba(8,18,34,0.50)",
            backdropFilter: "blur(10px)",
            WebkitBackdropFilter: "blur(10px)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 1,
            position: "relative",
            zIndex: 1,
          }}
        >
          {!collapsed && (
            <Box sx={{ px: 1 }}>
              <Typography sx={{ fontSize: "8px", color: "#506280", letterSpacing: "0.2px" }}>
                Powered by AutomationEdge
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
    </Drawer>
  );
}
